import { createRouter, createWebHistory } from 'vue-router'
import token from '@/utils/token'
import { getuserprofile } from '@/api/user'

const home = () => import('@/views/home/index.vue')
const homejobs = () => import('@/views/home/jobsindex.vue')
const homejob = () => import('@/views/home/jobsindexs.vue')
const homeresumes = () => import('@/views/home/resumesindex.vue')
const homearticles = () => import('@/views/home/articles.vue')
const homearticlesm = () => import('@/views/home/articlesm.vue')
const homesenior = () => import('@/views/home/senior.vue')
const resumeshome = () => import('@/views/resumes/home/index.vue')
const userindex = () => import('@/views/user/indexs.vue')
const login = () => import('@/views/login/index.vue')
const print = () => import('@/views/print/index.vue')
const resumeitem = () => import('@/views/itemresume/index.vue')
const companyitem = () => import('@/views/itemcompany/index.vue')
const resumeitembasic = () => import('@/views/itemresumebasic/index.vue')
const companyitembasic = () => import('@/views/itemcompanybasic/index.vue')
const jobitem = () => import('@/views/itemjob/index.vue')
const reg = () => import('@/views/reg/index.vue')
const reguser = () => import('@/views/reguser/index.vue')
const userMain = () => import('@/views/user/index.vue')
const chats = () => import('@/views/chat/index.vue')
const apply = () => import('@/views/resumes/apply/index.vue')
const collection = () => import('@/views/resumes/collection/index.vue')
const invite = () => import('@/views/resumes/invite/index.vue')
const reading = () => import('@/views/resumes/reading/index.vue')
const readingme = () => import('@/views/resumes/readingme/index.vue')
const resume = () => import('@/views/resumes/resume/index.vue')
const resumes = () => import('@/views/resumes/resume/resume.vue')
const companyshome = () => import('@/views/companys/home/index.vue')
const companyscompany = () => import('@/views/companys/company/index.vue')
const companysjobs = () => import('@/views/companys/jobs/index.vue')
const companysjobse = () => import('@/views/companys/jobse/index.vue')
const companysapply = () => import('@/views/companys/apply/index.vue')
const companysinvite = () => import('@/views/companys/invite/index.vue')
const companyscollection = () => import('@/views/companys/collection/index.vue')
const companysreading = () => import('@/views/companys/reading/index.vue')
const companysreadingme = () => import('@/views/companys/readingme/index.vue')
const companysaccounts = () => import('@/views/companys/accounts/index.vue')
const companyadvertisement = () => import('@/views/companys/advertisement/index.vue')
const companysearch = () => import('@/views/companys/search/index.vue')
const resumesearch = () => import('@/views/resumes/search/index.vue')

const publicPaths = ['/', '/senior', '/articles', '/articlesm', '/jobssearch', '/jobs', '/resumessearch', '/reg', '/reguser', '/login', '/resumeitem', '/jobitem', '/companyitem']
const userProfileCacheTime = 30000
let cachedProfileToken = ''
let cachedProfileAt = 0
let cachedProfile = null
let profileRequest = null
let profileRequestToken = ''

function clearProfileCache () {
  cachedProfileToken = ''
  cachedProfileAt = 0
  cachedProfile = null
}

function hasCachedProfile (tokenValue) {
  return cachedProfileToken === tokenValue && cachedProfile != null && cachedProfile.usersid > 0 && Date.now() - cachedProfileAt < userProfileCacheTime
}

function cacheProfile (tokenValue, profile) {
  cachedProfileToken = tokenValue
  cachedProfileAt = Date.now()
  cachedProfile = profile
}

function redirectLogin (next) {
  token.settoken('utoken', '')
  clearProfileCache()
  next('/login')
}

function isPublicPath (path) {
  return publicPaths.indexOf(path) !== -1
}

const routes = [
  {
    path: '/',
    component: home
  },
  {
    path: '/jobs',
    component: homejob
  },
  {
    path: '/jobssearch',
    component: homejobs
  },
  {
    path: '/resumessearch',
    component: homeresumes
  },
  {
    path: '/senior',
    component: homesenior
  },
  {
    path: '/articles',
    component: homearticles
  },
  {
    path: '/articlesm',
    component: homearticlesm
  },
  {
    path: '/login',
    component: login
  },
  {
    path: '/reg',
    component: reg
  },
  {
    path: '/reguser',
    component: reguser
  },
  {
    path: '/print',
    component: print
  },
  {
    path: '/resumeitem',
    component: resumeitem
  },
  {
    path: '/companyitem',
    component: companyitem
  },
  {
    path: '/resumeitembasic',
    component: resumeitembasic
  },
  {
    path: '/companyitembasic',
    component: companyitembasic
  },
  {
    path: '/jobitem',
    component: jobitem
  },
  {
    path: '/resumes',
    component: resumes
  },
  // --沟通---------
  {
    path: '/chats',
    component: chats
  },
  {
    path: '/user',
    component: userMain,
    children: [
      {
        path: '/',
        component: userindex
      },
      {
        path: '/resumes/home',
        component: resumeshome
      },
      {
        path: '/apply',
        component: apply
      },
      {
        path: '/collection',
        component: collection
      },
      {
        path: '/invite',
        component: invite
      },
      {
        path: '/reading',
        component: reading
      },
      {
        path: '/readingme',
        component: readingme
      },
      {
        path: '/resume',
        component: resume
      },
      {
        path: '/resumes/search',
        component: resumesearch
      },
      // --企业管理------------------
      {
        path: '/companys/home',
        component: companyshome
      },
      {
        path: '/companys/company',
        component: companyscompany
      },
      {
        path: '/companys/jobs',
        component: companysjobs
      },
      {
        path: '/companys/jobse',
        component: companysjobse
      },
      {
        path: '/companys/apply',
        component: companysapply
      },
      {
        path: '/companys/invite',
        component: companysinvite
      },
      {
        path: '/companys/collection',
        component: companyscollection
      },
      {
        path: '/companys/reading',
        component: companysreading
      },
      {
        path: '/companys/readingme',
        component: companysreadingme
      },
      {
        path: '/companys/accounts',
        component: companysaccounts
      },
      {
        path: '/companys/advertisement',
        component: companyadvertisement
      },
      {
        path: '/companys/search',
        component: companysearch
      }
    ]
  }

]

const router = createRouter({
  history: createWebHistory(),
  routes
})

router.beforeEach((to, from, next) => {
  // if ((navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i))) {
  //   window.location.href = 'http://m.ordercn.cn'
  // }

  if (to.meta.title) {
    document.title = to.meta.title
  }
  if (isPublicPath(to.path)) {
    next()
  } else {
    const tokenValue = token.gettoken('utoken') || ''
    if (hasCachedProfile(tokenValue)) {
      next()
      return
    }
    if (profileRequest == null || profileRequestToken !== tokenValue) {
      profileRequestToken = tokenValue
      profileRequest = getuserprofile()
      profileRequest.then(() => {
        profileRequest = null
        profileRequestToken = ''
      }).catch(() => {
        profileRequest = null
        profileRequestToken = ''
      })
    }
    profileRequest.then(res => {
      if (res.data.status === 200) {
        if (res.data.resultbody.usersid != null) {
          // alert(JSON.stringify(res.data))
          if (res.data.resultbody.usersid > 0) {
            cacheProfile(tokenValue, res.data.resultbody)
            next()
          } else {
            redirectLogin(next)
          }
        } else {
          redirectLogin(next)
        }
      } else {
        alert(res.data.message)
        redirectLogin(next)
      }
    }).catch(res => {
      redirectLogin(next)
    })
  }
})

export default router
